import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const aesMdSideNav = {
  id: 'md',
  children: [
    {
      id: 'mdTierDashboard',
      displayName: 'Tier Dashboard',
      role: 'MD_CTRT_VIEW',
      icon: fas.faChartBar,
      route: '/md/tier-dashboard',
    },

    {
      id: 'mdPriceLookup',
      displayName: 'Price Lookup',
      role: 'MD_PRICE_RES_VIEW',
      icon: fas.faUsdCircle,
      route: '/md/price-lookup',
    },
  ],
};

export default aesMdSideNav;
